import './MonacoJSXHighlighter.css';
export * from './MonacoJSXHighlighter';
import { default as MonacoJSXHighlighter } from './MonacoJSXHighlighter';
export default MonacoJSXHighlighter;

